<div class="menu">
  <div class="menu__block">
    <strong>Company</strong>
    <a (click)="onCloseMenu()" routerLink="/about">About</a>
    <a (click)="onCloseMenu()" routerLink="/faq">FAQ</a>
    @if (false) {
      <a (click)="onCloseMenu()" routerLink="/plans">Plans</a>
    }
    <a (click)="onCloseMenu()" routerLink="/contacts">Contacts</a>
  </div>
  <div class="menu__block">
    <strong>Categories</strong>
    @for (category of categories$ | async; track category.id) {
      <a (click)="onCloseMenu()" [appCategory]="category.name">
        {{ category.name }}
      </a>
    }
  </div>
  <div class="menu__block">
    <strong>Policies</strong>
    <a (click)="onCloseMenu()" routerLink="/terms-of-use">Terms of Use</a>
    <a (click)="onCloseMenu()" routerLink="/privacy-policy">Privacy Policy</a>
    <a (click)="onCloseMenu()" routerLink="/refund-policy">Refund Policy</a>
    <a (click)="onCloseMenu()" routerLink="/licensing-policy">
      Licensing Policy
    </a>
  </div>
  <div class="menu__block">
    <strong>Help</strong>
    <a [href]="'mailto:' + environment.support_email">
      <span>
        {{ environment.support_email }}
      </span>
    </a>
    <div class="menu__social">
      <app-social-links classes="social_menu" />
    </div>
  </div>
</div>
